import {createContext} from 'react';
import type {Slots} from '../types/Slots';

export const SlotContext = createContext<Slots>({});
